/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'operations': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 0h1024v161.792H0V0zm88.064 765.952h380.928v215.04H342.016V1024h339.968v-43.008H555.008v-215.04h380.928v-552.96H88.064v552.96zm0 0"/>'
  }
})
